/**
 * localStorage key for a UI language the guest EXPLICITLY picked in the guest
 * portal header. It wins over the automatic rule in GuestPortalPage
 * (bookings.guest_language if fully translated, else English), so a guest who
 * chose Deutsch keeps Deutsch on the next visit instead of reverting to English.
 */
export const GUEST_LANGUAGE_CHOICE_KEY = 'guest-language-choice';
